/**
 * Validación y normalización de enlaces Telegram públicos (CTA, admin, env).
 * Centralizado para Bio premium simple, Reels y resolución premium-invite.
 */

export function trimOutboundCtaUrl(raw: string | undefined): string {
  const t = String(raw ?? "").trim();
  if (t.length < 12) return "";
  if (!/^https?:\/\//i.test(t)) return "";
  if (/your-|tu-|example|xxx/i.test(t)) return "";
  return t;
}

/** `https://…` o `t.me/…` / `telegram.me/…` sin esquema (frecuente en admin / AR). */
export function normalizePublicOutboundUrl(raw: string): string {
  const trimmed = String(raw ?? "").trim();
  if (!trimmed) return "";
  const direct = trimOutboundCtaUrl(trimmed);
  if (direct) return direct;
  let t = trimmed.replace(/^\/+/, "");
  if (!/^https?:\/\//i.test(t)) {
    if (/^(t\.me|telegram\.me|telegram\.dog)\//i.test(t)) {
      t = `https://${t}`;
    } else {
      return "";
    }
  }
  return trimOutboundCtaUrl(t);
}
